import React from "react";

import PropTypes from "prop-types";
import { setSort } from "QuotePage/Actions";
import { getSortOrder } from "QuotePage/Selectors";
import { connect } from "react-redux";
import AnalyticsTracking from "Utils/AnalyticsTracking";

import { DropdownButton } from "Cobalt/Dropdown";
import { CompactMenuItem } from "Cobalt/MenuItem";

const SORT_LABEL = {
  score: "Recommended",
  average_monthly_premium: "Monthly Cost",
};

function SortDropdown({ currentSort, onSelect }) {
  return (
    <DropdownButton title="Sort by" color="ghost" className="text-sm" onSelect={onSelect} dropdownClassName="rounded-xl" sort dropdownPosition="right" p={3}>
      <CompactMenuItem itemType="dropdown" eventKey="score" currentSort={currentSort}>
        Recommended
      </CompactMenuItem>
      <CompactMenuItem itemType="dropdown" eventKey="average_monthly_premium" currentSort={currentSort}>
        Monthly Cost
      </CompactMenuItem>
    </DropdownButton>
  );
}

SortDropdown.propTypes = {
  currentSort: PropTypes.string.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  className: ownProps.className,
  currentSort: getSortOrder(state),
});

const mapDispatchToProps = (dispatch) => ({
  onSelect: (value) => {
    AnalyticsTracking.trackEvent("plans_sorted", {
      sort_by: SORT_LABEL[value],
    });

    dispatch(setSort(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SortDropdown);
